import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    container: {
        paddingTop: '24px',
    },
    sectionTitle: {
        color: '#597DDA',
        fontWeight: 700,
        fontSize: '1rem',
        marginBottom: '8px',
    },
    divider: {
        marginTop: '16px',
        marginBottom: '24px',
    },
}));
